(function($) {

    var changeOpenedAccordionHeaderTitle = function() {
        $('.accordion').find('.accordion-header').addClass('opened');
        $('.accordion').find('.accordion-header-icon').children().removeClass('ai-plus');
        $('.accordion').find('.accordion-header-icon').children().addClass('ai-minus');
        $('.accordion').find('.collapsed').parent().removeClass('opened');
        $('.accordion').find('.collapsed').find('.accordion-header-icon').children().toggleClass('ai-minus').toggleClass('ai-plus');
    }

    changeOpenedAccordionHeaderTitle();
    $('.collapse').on('shown.bs.collapse', changeOpenedAccordionHeaderTitle);
    $('.collapse').on('hidden.bs.collapse', changeOpenedAccordionHeaderTitle);

})(jQuery);
